import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { PnlResponseModel } from '@/types'

export const getPnLMetrics = async (
  branchName: string,
  startDate: string,
  endDate: string
): Promise<PnlResponseModel> => {
  try {
    const response = await axios.get(`${BASE_URL}/pnl`, {
      params: {
        start_month: startDate,
        end_month: endDate,
        branch_names: branchName,
        limit: 1000,
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
